export default {
  cars: [
    {
      name: "ZFR 1.0",
      image: "zfr1.jpg",
      Specifications: [
        {
          name: "Chassis ",
          value: "Tubular Space Frame (Mild Steel round)"
        },
        {
          name: "Power",
          value: "22.11 BHP @9300 rpm"
        },
        {
          name: "Weight",
          value: "301 kg"
        },
        {
          name: "Bodyworks",
          value: "FRP"
        },
        {
          name: "Engine",
          value: "250cc, Honda CBR 250R"
        },
        {
          name: "Tyres",
          value: "13 YOKOHAMA High Performance Tyres"
        },
        {
          name: "Wiring",
          value: "Standard Wiring"
        },
        {
          name: "ECU",
          value: "Stock ECU"
        },
        {
          name: "Suspension",
          value: "Double Wishbone unequal length push rod actuated"
        },
        {
          name: "Cooling",
          value: "Stock Cooling System"
        }
      ],
      Team: [
        {
          designation: "Mechanical",
          name: "Abhishek Pathak"
        },
        {
          designation: "Mechanical",
          name: "Meraj Ahmad"
        },
        {
          designation: "Mechanical",
          name: "Shashank Gupta"
        },
        {
          designation: "Mechanical",
          name: "Prashant Singh"
        },
        {
          designation: "Mechanical",
          name: "Ishan Sharma"
        },
        {
          designation: "Mechanical",
          name: "Pushkin Mittal"
        },
        {
          designation: "Mechanical",
          name: "Prasenjit Tomar"
        },
        {
          designation: "Mechanical",
          name: "Kushagra Kumar"
        },
        {
          designation: "Mechanical",
          name: "Rahul Sharma"
        },
        {
          designation: "Electronics",
          name: "Himank Gulati"
        },
        {
          designation: "Electronics",
          name: "Sahil Abbas Zaidi"
        },
        {
          designation: "Mechanical",
          name: "Chandresh Gandhi"
        },
        {
          designation: "Mechanical",
          name: "Prateek Goyal"
        },
        {
          designation: "Electronics",
          name: "Tushar Singhal"
        },
        {
          designation: "Mechanical",
          name: "Mehul Varshney"
        },
        {
          designation: "Mechanical",
          name: "Mohd. Afzal Shadab"
        },
        {
          designation: "Mechanical",
          name: "Arpit Upadhyay"
        },
        {
          designation: "Mechanical",
          name: "Ayush Mittal"
        },
        {
          designation: "Mechanical",
          name: "Irfan Khan"
        }
      ]
    },
    {
      name: "ZFR 2.0",
      image: "zfr2.jpg",
      Specifications: [
        {
          name: "Chassis ",
          value: "Tubular Space Frame (AISI-4130 Steel round)"
        },
        {
          name: "Power",
          value: "22.11 BHP @9300 rpm"
        },
        {
          name: "Weight",
          value: "301 kg"
        },
        {
          name: "Bodyworks",
          value: "GFRP"
        },
        {
          name: "Engine",
          value: "250cc, Honda CBR 250R"
        },
        {
          name: "Tyres",
          value: '13" YOKOHAMA High Performance Tyres'
        },
        {
          name: "Wiring",
          value: "Standard Wiring"
        },
        {
          name: "ECU",
          value: "Stock ECU"
        },
        {
          name: "Suspension",
          value: "Double Wishbone unequal length push rod actuated"
        },
        {
          name: "Cooling",
          value: "Stock Cooling System"
        }
      ],
      Team: [
        {
          designation: "Team Captain:",
          name: "Arpit upadhyaya"
        },
        {
          designation: "Vehicle Dynamics Lead:",
          name: "Mohammad Faraz"
        },
        {
          designation: "Vehicle Dynamics team member:",
          name: "Faizan Anwar"
        },
        {
          designation: "Vehicle Dynamics team member:",
          name: "Aasim Noor"
        },
        {
          designation: "Vehicle Dynamics team member:",
          name: "Aayush Mittal"
        },
        {
          designation: "Chassis Lead:",
          name: "Irfan Ahmed"
        },
        {
          designation: "Chassis team member:",
          name: "Wamiq Hashmi"
        },
        {
          designation: "Chassis team member:",
          name: "Areeb Mahmood"
        },
        {
          designation: "Power Train Lead:",
          name: "Anchal Varshney"
        },
        {
          designation: "Power Train team member:",
          name: "Mehul Varshney"
        },
        {
          designation: "Power Train team member:",
          name: "Arpit upadhyaya"
        },
        {
          designation: "Power Train team member:",
          name: "Mridul"
        },
        {
          designation: "Power Train team member:",
          name: "Hamza Khan"
        },
        {
          designation: "Electronics Lead:",
          name: "Hamza"
        },
        {
          designation: "Electronics team member:",
          name: "Subham Varshney"
        },
        {
          designation: "Team Manager:",
          name: "Aman Agarwal"
        },
        {
          designation: "Team Captain:  ",
          name: "Arpit upadhyaya"
        }
      ]
    },
    {
      name: "ZFR 3.0",
      image: "zfr3.jpg",
      Specifications: [
        {
          name: "Chassis",
          value: "Tubular Space Frame (AISI-4130 Steel round)"
        },
        {
          name: "Power",
          value: "22.11 BHP @9300 rpm"
        },
        {
          name: "Weight",
          value: "190 kg"
        },
        {
          name: "Bodyworks",
          value: "CFRP"
        },
        {
          name: "Engine",
          value: "250cc, Honda CBR 250R(2014 Model)"
        },
        {
          name: "Tyres",
          value: "10” Hoosier Formula Spec Tyres"
        },
        {
          name: "Wiring",
          value: "Custom Built Wiring Harness"
        },
        {
          name: "ECU",
          value: "Stock ECU with BAZZAZ"
        },
        {
          name: "Suspension",
          value: "Double Wishbone unequal length pull and push rod actuated"
        },
        {
          name: "Cooling",
          value: "Self Designed and Fabricated Cooling System"
        }
      ],
      Team: [
        {
          designation: "Team Captain:  ",
          name: "Arpit upadhyaya"
        },
        {
          designation: "Vehicle Dynamics Lead:",
          name: "Mohammad Faraz"
        },
        {
          designation: "Vehicle Dynamics team member:",
          name: "Faizan Anwar"
        },
        {
          designation: "Vehicle Dynamics team member:",
          name: "Aasim Noor"
        },
        {
          designation: "Vehicle Dynamics team member:",
          name: "Aayush Mittal"
        },
        {
          designation: "Chassis Lead:",
          name: "Irfan Ahmed"
        },
        {
          designation: "Chassis team member:",
          name: "Wamiq Hashmi"
        },
        {
          designation: "Chassis team member:",
          name: "Areeb Mahmood"
        },
        {
          designation: "Power Train Lead:",
          name: "Anchal Varshney"
        },
        {
          designation: "Power Train team member:",
          name: "Mehul Varshney"
        },
        {
          designation: "Power Train team member:",
          name: "Arpit upadhyaya"
        },
        {
          designation: "Power Train team member:",
          name: "Mridul"
        },
        {
          designation: "Power Train team member:",
          name: "Hamza Khan"
        },
        {
          designation: "Electronics Lead:",
          name: "Hamza"
        },
        {
          designation: "Electronics team member:",
          name: "Subham Varshney"
        },
        {
          designation: "Team Manager:",
          name: "Aman Agarwal"
        },
        {
          designation: "Team Captain:  ",
          name: "Arpit upadhyaya"
        }
      ]
    },
    {
      name: "ZFR 4.0",
      image: "zfr4.jpg",
      Specifications: [
        {
          name: "Chassis",
          value: "Tubular Space Frame (AISI-4130 Steel round)"
        },
        {
          name: "Power",
          value: "22.11 BHP @9300 rpm"
        },
        {
          name: "Weight",
          value: "208 kg"
        },
        {
          name: "Bodyworks",
          value: "GFRP"
        },
        {
          name: "Engine",
          value: "250cc, Honda CBR 250R (2014 Model)"
        },
        {
          name: "Tyres",
          value: "10” Hoosier Formula Spec Tyres"
        },
        {
          name: "Wiring",
          value: "Custom Built Wiring Harness"
        },
        {
          name: "ECU",
          value: "Stock ECU with BAZZAZ"
        },
        {
          name: "Suspension",
          value: "Double Wishbone unequal length pull and push rod actuated"
        },
        {
          name: "Cooling",
          value: "Self Designed and Fabricated Cooling System"
        }
      ],
      Team: [
        {
          designation: "Team Captain:",
          name: "Shubham Varshney"
        },
        {
          designation: "Vehicle Dynamics Lead:",
          name: "Faizan Anwar"
        },
        {
          designation: "Vehicle Dynamics team member:",
          name: "Mohd Tashif"
        },
        {
          designation: "Vehicle Dynamics team member:",
          name: "Saad Khan"
        },
        {
          designation: "Vehicle Dynamics team member:",
          name: "Syed Nasir Ashgar"
        },
        {
          designation: "Chassis Lead:",
          name: "Wamiq Hashmi"
        },
        {
          designation: "Chassis team member:",
          name: "Qazi Mohammad Taha"
        },
        {
          designation: "Chassis team member:",
          name: "Rohit Shareshwat"
        },
        {
          designation: "Power Train Lead:",
          name: "Areeb Mahmood"
        },
        {
          designation: "Power Train team member:",
          name: "Nafees Ahmad"
        },
        {
          designation: "Power Train team member:",
          name: "Nakul Varshney"
        },
        {
          designation: "Electronics Lead:",
          name: "Shubham Varshney"
        },
        {
          designation: "Electronics team member:",
          name: "Prashant Varshant Singh"
        },
        {
          designation: "Electronics team member:",
          name: "Anurita Verwal"
        },
        {
          designation: "Electronics team member:",
          name: "Shadman Faraz"
        },
        {
          designation: "Electronics team member:",
          name: "Shivam Upadhyaya"
        },
        {
          designation: "Electronics team member:",
          name: "Asadullah Khan"
        },
        {
          designation: "Team Manager:",
          name: "Kamran Shakir"
        },
        {
          designation: "Management Team Member:",
          name: "Syed Ali Zaheen"
        },
        {
          designation: "Management Team Member:",
          name: "Rishabh"
        }
      ]
    },
    {
      name: "ZFR 4.1",
      image: "zfr4.1.jpg",
      Specifications: [],
      Team: [
        {
          designation: "Team Captain:",
          name: "Sarif Anwar"
        },
        {
          designation: "Vehicle Dynamics Lead:",
          name: "Mohd Tashif"
        },
        {
          designation: "Vehicle Dynamics team member:",
          name: "Syed Nasir Ashgar"
        },
        {
          designation: "Vehicle Dynamics team member:",
          name: "Rehan Abad Siddiqui"
        },
        {
          designation: "Vehicle Dynamics team member:",
          name: "Yogesh Kumar"
        },
        {
          designation: "Vehicle Dynamics team member:",
          name: "Hina Tomar"
        },
        {
          designation: "Vehicle Dynamics team member:",
          name: "Waris Khan"
        },
        {
          designation: "Chassis Lead:",
          name: "Rishabh"
        },
        {
          designation: "Chassis team member:",
          name: "Himanshu Verma"
        },
        {
          designation: "Power Train Lead:",
          name: "Nafees Ahmad"
        },
        {
          designation: "Power Train team member:",
          name: "Pradeep Kumar"
        },
        {
          designation: "Power Train team member:",
          name: "Suboor Aziz"
        },
        {
          designation: "Electronics Lead:",
          name: "Shivam Upadhyaya"
        },
        {
          designation: "Electronics team member:",
          name: "Pakhil\n                                                "
        },
        {
          designation: "Electronics team member:",
          name: "Mohit Kumar"
        },
        {
          designation: "Team Manager:",
          name: "Qazi Mohammad Taha"
        },
        {
          designation: "Management Team Member:",
          name: "Burhan Shamsi"
        }
      ]
    },
    {
      name: "ZFR 5.0",
      image: "zfr5.jpg",
      Specifications: [
        {
          name: "Chassis",
          value: "Tabular Space Frame (AISI-4130 Steel round)"
        },
        {
          name: "Power",
          value: "22.11 BHP @9300 rpm"
        },
        {
          name: "Weight",
          value: "175 kg"
        },
        {
          name: "Bodyworks",
          value: "CFRP"
        },
        {
          name: "Engine",
          value: "390cc, KTM 390 (2017 Model)"
        },
        {
          name: "Tyres",
          value: "10” Hoosier Formula Spec Tyres"
        },
        {
          name: "Wiring",
          value: "Custom Built Wiring Harness"
        },
        {
          name: "ECU",
          value: "Stock ECU"
        },
        {
          name: "Suspension",
          value: "Double Wishbone unequal length pull and push rod actuated"
        },
        {
          name: "Cooling",
          value: "Self Designed and Fabricated Cooling System"
        }
      ],
      Team: [
        {
          designation: "Team Captain:",
          name: "Sarif Anwar"
        },
        {
          designation: "Vehicle Dynamics Lead:",
          name: "Mohd Tashif"
        },
        {
          designation: "Vehicle Dynamics team member:",
          name: "Sarif Anwar"
        },
        {
          designation: "Vehicle Dynamics team member:",
          name: "Rehan Abad Siddiqui"
        },
        {
          designation: "Vehicle Dynamics team member:",
          name: "Yogesh Kumar"
        },
        {
          designation: "Vehicle Dynamics team member:",
          name: "Burhan Shamsi"
        },
        {
          designation: "Vehicle Dynamics team member:",
          name: "Waris Khan"
        },
        {
          designation: "Chassis Lead:",
          name: "Qazi Mohd Taha"
        },
        {
          designation: "Chassis team member:",
          name: "Tazeem Khan"
        },
        {
          designation: "Power Train Lead:",
          name: "Mohd Suboor Aziz"
        },
        {
          designation: "Power Train team member:",
          name: "Swarnima Chaudhary"
        },
        {
          designation: "Power Train team member:",
          name: "Mohd Atif Qazi"
        },
        {
          designation: "Electronics Lead:",
          name: "Mohit Mangal"
        },
        {
          designation: "Electronics team member:",
          name: "Hina Tomar"
        },
        {
          designation: "Electronics team member:",
          name: "Kunal Sharma"
        },
        {
          designation: "Team Manager:",
          name: "Qazi Mohd Taha"
        },
        {
          designation: "Management Team Member:",
          name: "Burhan Shamsi"
        },
        {
          designation: "Management Team Member:",
          name: "Arsalan Sartaj"
        },
        {
          designation: "Management Team Member:",
          name: "Meesum Raza Zaidi"
        },
        {
          designation: "Management Team Member:",
          name: "Vinayak Varshney"
        },
        {
          designation: "Management Team Member:",
          name: "Imad Uddin"
        }
      ]
    }
  ],
  events: [
    {
      name: "Auto Expo 2018",
      description:"Auto Expo is automotive show held in Greater Noida , Uttar Pradesh India. It’s Asia’s largest and world’s second largest motor show. It is organized group of following associations : Automotive Component Manufacturers Association(ACMA), Confederation of Indian Industry (CII) and Society of Indian Automobile Manufacturers (SIAM).",
      images: [
        {
          name: "DSC_2842.jpg"
        },
        {
          name: "DSC_3013.jpg"
        },
        {
          name: "DSC_3459.jpg"
        },
        {
          name: "excellentDisplay.jpg"
        },
        {
          name: "Formula1_forceIndiaF1.jpg"
        },
        {
          name: "fromParliament.jpg"
        },
        {
          name: "DSC_2842.jpg"
        },
        {
          name: "KrantiSirNDTVRaftar.jpg"
        },
        {
          name: "NDTVPrime.jpg"
        },
        {
          name: "NDTVPrime1.jpg"
        },
        {
          name: "NDTVRaftarInter.jpg"
        },
        {
          name: "OpenSi.jpg"
        },
        {
          name: "PrincipalSirVisi.jpg"
        },
        {
          name: "sponsor.jpg"
        },
        {
          name: "ZFR3_1.jpg"
        }
      ]

    },
    {
      name: "Formula Bharat 2020",
      description:"Formula Bharat is an Indian Formula Student-style engineering design competition in which students from colleges and universities all over the country, compete with a life-size formula-style vehicle in areas of engineering design, overall cost, marketability and dynamic performance. The series replicates the global student Formula series hosted in around 11 countries per year.",
      images: [
        {
          name: "_KEV7642.jpg"
        },
        {
          name: "DSC_0006.NEF.jpg"
        },
        {
          name: "DSC_0282.NEF.jpg"
        },
        {
          name: "DSC_0322.NEF.jpg"
        },
        {
          name: "DSC_0341.NEF.jpg"
        },
        {
          name: "DSC_0688.NEF.jpg"
        },
        {
          name: "DSC_0738.NEF.jpg"
        },
      ]

    },
    {
      name: "SUPRA SAE INDIA 2019",
      description: "SUPRA SAEIndia is an exciting competition which presents undergraduate engineering students with a challenging task of designing, simulating and modelling a formula type car. Each team is required to design and fabricate a prototype of the racecar in accordance with the strict rules and guidelines provided to them. The car is supposed to perform in a dynamic event on a live race track",
      images: [
        {
          name: "IMG_20190717_164232.jpg"
        },
        {
          name: "IMG-3391.jpg"
        },
        {
          name: "IMG20190716094112.jpg"
        },
        {
          name: "IMG20190716151835.jpg"
        },
        {
          name: "IMG20190716185900.jpg"
        },
        {
          name: "IMG20190716191611.jpg"
        },
        {
          name: "IMG20190717154722.jpg"
        },
      ]

    },
    {
      name: "Formula Student UK16",
      description: "Formula Student is a student engineering competition held annually in the UK. Student teams from around the world design, build, test, and race a small-scale formula style racing car. The cars are judged on a number of criteria as listed below. It is run by the Institution of Mechanical Engineers and uses the same rules as the original Formula SAE with supplementary regulations.",
      images: [
        {
          name: "_DSC0508.jpg"
        },
        {
          name: "DSC_1595jpg.jpg"
        },
        {
          name: "IMG_20160714_151820_HDR.jpg"
        },
        {
          name: "IMG_20160717_153910_HDR .jpg"
        },
      ]

    },
    {
      name: "Formula Student UK18",
      description: "Formula Student is a student engineering competition held annually in the UK. Student teams from around the world design, build, test, and race a small-scale formula style racing car. The cars are judged on a number of criteria as listed below. It is run by the Institution of Mechanical Engineers and uses the same rules as the original Formula SAE with supplementary regulations.",
      images: [
        {
          name: "ab.jpg"
        },
        {
          name: "IMG_20180712_204326.jpg"
        },
        {
          name: "IMG_20180714_163920.jpg"
        },
      ]

    }
  ]
};
